<template>
  <div class="">
    <div v-if="product.price == null && product.variation == 0">
      <div class="col-12 text-center">
        <p class="text-center btn btn-primary mx-auto rounded-pill">{{ findAttributeOnSiteInfo('setNullPrice')[0] }}</p>
      </div>
    </div>
    <div v-else>
      <div v-if="product.variation == 1">

        <div class="text-right  border-top">
          <p class="pt-4">لطفا یکی از ویژگی های محصول را انتخاب کنید.</p>
          <div class="d-inline-block mx-2" v-for="feature in productFeatures(product)" :key="feature.id">
            <button @click="selectFirstFeatureFunction(product,feature)"
                    :class="selectedFeature_1 == feature.id ? 'btn btn-primary text-white' : 'btn btn-outline-primary text-dark'"
                    :key="feature.id"
            >{{ feature.value }}
            </button>
          </div>

          <div class="my-3" v-if="!(selectedFeature_1=='null') && countProductFeature(product) == 2">
            <div class="d-inline-block mx-2" v-for="feature in featureValues(product)">
              <button
                  @click="selectSecondFeatureFunction(product,feature)"
                  :class="selectedFeature_2 == feature.id ? 'btn btn-primary text-white' : 'btn btn-outline-primary text-dark'">
                {{ feature.value }}
              </button>
            </div>
          </div>


        </div>


        <div class="my-3 col" v-if="showButtonAddToProduct(product)">
          <del v-if="offer > 0">
            <h3 class="m-auto text-muted">
              {{ formatNumber(parseInt(price)) }} تومان
            </h3>
          </del>
          <h2 class="m-auto">
            {{ formatNumber(parseInt(price - offer)) }} تومان
          </h2>
        </div>

        <div class="my-4" v-if="showButtonAddToProduct(product)">

          <img v-if="featureImageSource(sub_product.image)" class="product-feature"
               :src="featureImageSource(sub_product.image)" :alt="product.name">
          <div class="my-2"
               v-if="findAttributeOnSiteInfo('product_unit_warning')[0] >= sub_product.quantity && sub_product.quantity != 0">
            <p>
              {{ sub_product.quantity }} عدد از این محصول باقی مانده است
            </p>
          </div>
          <div v-if="sub_product.quantity > 0 || sub_product.quantity === null">
            <button
                v-if="isProductInShoppingCart == false"
                @click="addToCart(product,sub_product)"
                class="row my-4 btn rounded-pill text-white btn-primary">
              {{ buttonText }}
            </button>

            <m-shopping-cart-quantity-manager1 @productRemove="isProductInShoppingCartFunction()" class="my-5" v-else
                                               :order="order" :item="order_product"/>
          </div>
          <div v-else>
            <h2 class="text-center my-3 btn btn-primary rounded-pill">ناموجود</h2>
          </div>

        </div>


      </div>
      <div v-else>
        <del v-if="calculatePriceAndOffer(product)['offer'] > 0">
          <h3 class="m-auto text-muted">
            {{ formatNumber(parseInt(calculatePriceAndOffer(product)['price'])) }} تومان
          </h3>
        </del>
        <h2 class="m-auto">
          {{
            formatNumber(parseInt(calculatePriceAndOffer(product)['price'] - calculatePriceAndOffer(product)['offer']))
          }} تومان
        </h2>

        <div class="my-2"
             v-if="findAttributeOnSiteInfo('product_unit_warning')[0] >= product.quantity && product.quantity != 0">
          <p>
            {{ product.quantity }} عدد از این محصول باقی مانده است
          </p>
        </div>

        <button
            v-if="isProductInShoppingCart == false"
            @click="addToCart(product,sub_product)"
            class="mt-4 btn rounded-pill row text-white btn-primary">
          {{ buttonText }}
        </button>
        <div v-else>
          <m-shopping-cart-quantity-manager1 class="my-5" @productRemove="isProductInShoppingCartFunction()"
                                             :order="order"
                                             :item="order_product"/>
          <m-a :href="{name:shoppingCartLink}">
            <button class="btn btn-primary rounded-pill">مشاهده سبد خرید</button>
          </m-a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";
import {mapGetters} from "vuex";
import {findHashProductOnLocalStorage} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/ShoppingCart";
import mShoppingCartQuantityManager1 from "../Product/ShoppingCartQuantityManager1";
import mA from "../Tags/A";

function featureImageSource(imageLink) {
  return imageLink != null ? findAttributeOnSiteInfo('host')[0] + '/storage/' + imageLink : null
}

export default {
  name: "SingleProductPrice2",
  components: {mShoppingCartQuantityManager1, mA},
  props: {
    buttonText: {},
    addToCartFunction: {},
    product: {},
  },
  data() {
    return {
      selectedFeature_1: 'null',
      selectedFeature_2: 'null',
      offer: 0,
      price: 0,
      sub_product: null,
      order_product: {},
      isProductInShoppingCart: false,
    }
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'User/isAuthenticated',
      order: "ShoppingCart/getSidebarBasketData",
    }),
    shoppingCartLink() {
      return this.isAuthenticated ? 'ShoppingCart' : 'UnAuthenticatedShoppingCart'
    }

  },
  methods: {
    productFeatures(product) {
      const product_features = product.features;
      let product_variation = [];


      for (let feature in product_features) {
        feature = product_features[feature]
        // feature.type == 'list' &&  feature.feature_values.sub_product == 1 || feature.type == 'list' && feature.feature_values.sub_product == 0 && feature.feature_values.sub_product


        if (
            feature.type == 'list' && feature.feature_values.sub_product == 1 ||
            feature.type == 'list' && feature.feature_values.sub_product == 0 && feature.feature_values.link_feature != null
        ) {

          let feature_attribute_id = feature.feature_values.feature_attribute_id;
          let feature_attributes = feature.feature_attributes

          feature_attributes.forEach(item => {
            if (item.id == feature_attribute_id) {
              product_variation.push({...item, active_quantity: feature.feature_values.active_quantity})
            }
          })


        }

      }

      var ids = [];
      var result = []

      // unique object of the list of product_variation
      product_variation.forEach((item) => {

        if (ids.indexOf(item.id) == -1) {
          ids.push(item.id)
          result.push(item)
        }

      })


      return result

    },
    featureValues(product) {

      let values = []

      const product_features = product.features;
      let product_variation = [];

      for (let feature in product_features) {
        feature = product_features[feature]


        if (feature.feature_values.link_feature_value != null) {
          if (feature.feature_values.feature_attribute_id == this.selectedFeature_1) {


            let linkFeatureAtrributeId = feature.feature_values.link_feature_value.feature_attribute_id;
            let linkFeatureAtrributs = feature.feature_values.link_feature.feature_attributes;

            linkFeatureAtrributs.forEach(item => {
              if (item.id == linkFeatureAtrributeId) {

                values.push({...item, active_quantity: feature.feature_values.active_quantity})
              }
            })

          }
        }


      }

      return values

    },
    bulkFounder(product) {
      let bulks = product.bulks
      let quantity = 1
      if (this.order_product.quantity !== undefined) {
        quantity = this.order_product.quantity;
      } else {
        quantity = 1;
      }

      // console.log(quantity, 'order_product quantity')

      let selectedItems = []

      bulks.forEach(item => {
        item['sub_price'] = item['price'] - item['offer']
        if (item['q_1'] <= quantity && (item['q_2'] >= quantity || item['q_2'] === null)) {
          selectedItems.push(item)
        }

      })

      selectedItems.sort(function (a, b) {
        return a.price - b.offer;
      });


      return selectedItems.length > 0 ? selectedItems : false
    },
    calculatePriceAndOffer(product) {

      if (product.variation == 1) {
        const product_features = product.features;

        for (let feature in product_features) {

          feature = product_features[feature]
          if (this.countProductFeature(product) == 2) {
            if (feature.feature_values.link_feature_value != null && feature.feature_values.feature_attribute_id == this.selectedFeature_1 && feature.feature_values.link_feature_value.feature_attribute_id == this.selectedFeature_2 && feature.feature_values.variation == 1) {
              this.offer = feature.feature_values.link_feature_value.offer
              this.price = feature.feature_values.link_feature_value.price
              this.sub_product = feature.feature_values.link_feature_value;
              if (feature.feature_values.image != null) {
                this.sub_product.image = feature.feature_values.image
              } else {
                this.sub_product.image = feature.feature_values.link_feature_value.image
              }
            }
          } else if (feature.feature_values.feature_attribute_id == this.selectedFeature_1 && feature.feature_values.variation == 1) {
            this.offer = feature.feature_values.offer
            this.price = feature.feature_values.price
            this.sub_product = feature.feature_values
          }
        }
      } else {
        this.offer = product.offer
        this.price = product.price
        if (this.isAuthenticated) {
          const bulkFounder = this.bulkFounder(product)

          if (bulkFounder !== false) {
            let bulk = bulkFounder.slice(-1)[0];
            return {
              offer: bulk['offer'],
              price: bulk['price'],
              sub_product: null,
            }
          }

        }
        /* todo write bulk here before calculate if we found item, we return price
         otherwise we show error for that quantity */
      }

      return {
        offer: this.offer,
        price: this.price,
        sub_product: this.sub_product,
      }


    },
    showButtonAddToProduct(product) {
      //  this.selectedFeature_2 != 'null' && this.selectedFeature_1 != 'null'

      if (this.countProductFeature(product) == 2) {
        return this.selectedFeature_2 != 'null' && this.selectedFeature_1 != 'null'
      } else {
        return this.selectedFeature_1 != 'null'
      }

    },
    countProductFeature(product) {
      let count = 0;
      for (let feature in product.features) {
        feature = product.features[feature]
        if (feature.feature_values.link_feature_value == null) {
          count = 1 > count ? 1 : count
        } else {
          count = 2 > count ? 2 : count
        }
      }
      return count
    },
    formatNumber,
    featureImageSource,
    findHashProductOnLocalStorage,
    checkOrder(product) {
      let result = false;
      if (this.order.items !== undefined) {
        this.order.items.forEach(item => {
          if (item.product.id === product.id) {
            if (this.sub_product == null) {
              this.order_product = item
              result = true
            } else {
              if (item.sub_product == this.sub_product.id) {
                this.order_product = item
                result = true
              }
            }
          }
        })
      }
      if (!result) { // reset order_product if we dont find any thing
        this.order_product = {}
      }
      return result
    },
    checkUnAuthBasket(product) {

      if (localStorage.getItem('products') !== null) {

        const localStorageProducts = JSON.parse(localStorage.getItem('products'));
        // sub_product_id

        let tempProduct = Object.assign({}, product);

        if (tempProduct['variation'] === 1) {
          tempProduct['sub_product_id'] = this.sub_product.id
        }

        const productHash = this.findHashProductOnLocalStorage(tempProduct);
        const productStatus = productHash != undefined;
        if (productStatus) {
          if (!this.isAuthenticated) {
            this.order_product = {
              id: product.id,
              sub_product: this.sub_product,
              quantity: localStorageProducts[productHash]['quantity'],
              productHash: productHash,
              product: this.product
            }
          }
        }
        return productStatus
      } else {
        return false
      }
    },
    selectFirstFeatureFunction(product, feature) {
      this.selectedFeature_1 = feature.id
      this.calculatePriceAndOffer(product)
      this.isProductInShoppingCartFunction()
    },
    selectSecondFeatureFunction(product, feature) {
      this.selectedFeature_2 = feature.id
      this.calculatePriceAndOffer(product)
      this.isProductInShoppingCartFunction()
    },
    isProductInShoppingCartFunction() {
      if (this.isAuthenticated) {
        this.isProductInShoppingCart = this.checkOrder(this.product)
        return true
      }
      this.isProductInShoppingCart = this.checkUnAuthBasket(this.product)
      return true
    },
    async addToCart(product, sub_product) {
      await this.addToCartFunction(product, sub_product)
      this.isProductInShoppingCartFunction();
      await this.$forceUpdate();
    },
    refreshFunction() {
      this.$forceUpdate();
    }
  },
  async mounted() {
    if (this.product.variation == 0) {
      this.isProductInShoppingCartFunction();
    }
    window.addEventListener('click', this.refreshFunction);
    window.addEventListener('DOMContentLoaded', this.refreshFunction);
  },
  watch: {
    '$route': {
      handler: function () {
        this.sub_product = null
        this.selectedFeature_1 = 'null'
        this.selectedFeature_2 = 'null'
        this.offer = 0
        this.price = 0
        this.isProductInShoppingCart = false
      },
    },
    'order': {
      handler: function (oldValue, newValue) {
        this.isProductInShoppingCartFunction();
        this.$forceUpdate();
      },
    },
  }

}
</script>

<style scoped>
.product-feature {
  height: 350px;
  width: 100%;
  object-fit: contain;
}
</style>
